import DeleteDialog from "./DeleteDialog";
import SameDayCancelDialog from "./SameDayCancelDialog";
import ClassesTable from "./ClassesTable";
import { useClassesInfo } from "../hooks/useClassesInfo";

const ClassesInfo = () => {
  const {
    state: {
      appointments,
      clubNames,
      deleteDialog,
      sameDayCancelDialog,
      deleteSameDayCancelDialog,
      sameDayCancellations,
      isSameDayCancellationsLoading,
      userName,
    },
    actions: {
      setDeleteDialog,
      setSameDayCancelDialog,
      setDeleteSameDayCancelDialog,
      handleConfirmDelete,
      onClickDeleteClasses,
      onClickSameDayCancel,
      onDeleteSameDayCancel,
      handleConfirmSameDayCancel,
      handleConfirmDeleteSameDayCancel,
    },
  } = useClassesInfo();

  return (
    <>
      <DeleteDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={handleConfirmDelete}
      />
      <SameDayCancelDialog
        isOpen={sameDayCancelDialog}
        onClose={() => setSameDayCancelDialog(false)}
        onConfirm={handleConfirmSameDayCancel}
      />
      <DeleteDialog
        isOpen={deleteSameDayCancelDialog}
        onClose={() => setDeleteSameDayCancelDialog(false)}
        onConfirm={handleConfirmDeleteSameDayCancel}
      />
      <ClassesTable
        appointments={appointments}
        clubNames={clubNames}
        userName={userName}
        onClickDeleteClasses={onClickDeleteClasses}
        onClickSameDayCancel={onClickSameDayCancel}
        onDeleteSameDayCancel={onDeleteSameDayCancel}
        sameDayCancellations={sameDayCancellations}
        isSameDayCancellationsLoading={isSameDayCancellationsLoading}
      />
    </>
  );
};

export default ClassesInfo;
